import { CSSObject } from "styled-components";

interface LoadingIndicatorStyles {
  container: CSSObject;
}

const useLoadingIndicatorStyles = (): LoadingIndicatorStyles => {
  return {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    },
  };
};

export default useLoadingIndicatorStyles;
